import type {
  QueueActivity,
  QueueActivityBase,
  QueueActivityLog,
  ReadQueueActivityLogApiResponse,
} from 'lib-shared-types-api';

export const transformReadQueueActivityLogResponse = (
  response: ReadQueueActivityLogApiResponse,
): QueueActivity => {
  const users: Record<string, string> = {};
  for (const { id, name } of response.data.users) {
    users[id] = name;
  }

  const teams: Record<string, string> = {};
  for (const { id, name } of response.data.teams) {
    teams[id] = name;
  }

  return {
    activityLog: response.data.audit_log.map((log): QueueActivityLog => {
      const base: QueueActivityBase = {
        id: log.id,
        authorId: log.author_id,
        authorName: users[log.author_id] ?? '',
        organizationId: log.organization_id,
        timestamp: log.timestamp,
      };

      const eventPayload = JSON.parse(log.event.payload);

      switch (log.event.type) {
        case 'AgentAddedToQueue':
          return {
            ...base,
            type: log.event.type,
            agentId: eventPayload.agent_id ?? '',
            agentName: users[eventPayload.agent_id] ?? '',
            isViewOnly: eventPayload.is_view_only,
          };
        case 'AgentRemovedFromQueue':
          return {
            ...base,
            type: log.event.type,
            agentId: eventPayload.agent_id ?? '',
            agentName: users[eventPayload.agent_id] ?? '',
          };
        case 'AgentUpdatedInQueue':
          return {
            ...base,
            type: log.event.type,
            agentId: eventPayload.agent_id ?? '',
            agentName: users[eventPayload.agent_id] ?? '',
            isViewOnly: !!eventPayload.is_view_only,
          };

        case 'TeamAddedToQueue':
          return {
            ...base,
            type: log.event.type,
            teamId: eventPayload.team_id ?? '',
            teamName: teams[eventPayload.team_id] ?? '',
            isViewOnly: eventPayload.is_view_only,
          };
        case 'TeamRemovedFromQueue':
          return {
            ...base,
            type: log.event.type,
            teamId: eventPayload.team_id ?? '',
            teamName: teams[eventPayload.team_id] ?? '',
          };
        case 'TeamUpdatedInQueue':
          return {
            ...base,
            type: log.event.type,
            teamId: eventPayload.team_id ?? '',
            teamName: teams[eventPayload.team_id] ?? '',
            isViewOnly: !!eventPayload.is_view_only,
          };

        case 'QueueUpdated':
          return {
            ...base,
            type: log.event.type,
            updates: Object.keys(eventPayload.updates),
          };

        case 'QueueDerestricted':
        case 'QueueRestricted':
        case 'QueueArchived':
        case 'QueueUnarchived':
        case 'DefaultQueueSet':
        case 'QueueCreated':
          return { ...base, type: log.event.type };

        default:
          return { ...base, type: log.event.type };
      }
    }),
    lastKey: response.meta.last_key,
  };
};
